module.exports = __webpack_public_path__ + "static/media/m-tentens.18a4c21a.png";